'use strict';

var _classCallCheck = require("/var/apps/finb/axis-frontend/axis-fe-static/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/var/apps/finb/axis-frontend/axis-fe-static/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/var/apps/finb/axis-frontend/axis-fe-static/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/var/apps/finb/axis-frontend/axis-fe-static/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/var/apps/finb/axis-frontend/axis-fe-static/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-static/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _templateObject;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _theme = require('shared/styled/theme');
var _theme2 = _interopRequireDefault(_theme);
var _colors = require('shared/styled/colors');
var _colors2 = _interopRequireDefault(_colors);
var _themes = require('shared/constants/themes');
var _themes2 = _interopRequireDefault(_themes);
var _styledComponents = require('styled-components');
var _firstLoadUnAuthAction = require('../../actions/firstLoadUnAuthAction');
var _userDataActions = require('../../actions/userDataActions');
var _pushNotificationsActions = require('../../actions/pushNotificationsActions');
var _platforms = require('../../constants/platforms');
var _platforms2 = _interopRequireDefault(_platforms);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var GlobalStyle = _styledComponents.createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .cropper-view-box {\n    outline-color: ", "!important;\n  }\n\n  .ant-calendar-selected-date:not(.ant-calendar-disabled-cell) {\n    div {\n      background: ", "!important;\n      color: #fff!important;\n    }\n  }\n\n  .cropper-line, .cropper-point {\n    background-color: ", "!important;\n  }\n\n  .ant-calendar-decade-panel-selected-cell {\n    .ant-calendar-decade-panel-decade, .ant-calendar-decade-panel-decade:hover {\n      background-color: ", ";\n    }\n  }\n\n  .ant-calendar-decade-panel-cell:not(.ant-calendar-decade-panel-selected-cell) {\n    .ant-calendar-decade-panel-decade:hover {\n      border-color: ", ";\n      color: ", ";\n    }\n  }\n  .ant-calendar-year-panel-selected-cell {\n    a {\n      background-color: ", "!important;\n    }\n  }\n  .ant-calendar-year-panel-decade-select, \n  .ant-calendar-decade-panel-prev-century-btn,\n  .ant-calendar-decade-panel-next-century-btn,\n  .ant-calendar-year-panel-next-decade-btn,\n  .ant-calendar-year-panel-prev-decade-btn {\n    &:hover {\n      color: ", "!important;\n    }\n  }\n  .ant-calendar-month-panel-header a:hover {\n    color: ", ";\n  }\n\n  .ant-calendar-month-panel-prev-year-btn, \n  .ant-calendar-month-panel-next-year-btn, \n  .ant-calendar-month-panel-year-select-content,\n  .ant-calendar-prev-year-btn,\n  .ant-calendar-next-year-btn, \n  .ant-calendar-prev-month-btn, \n  .ant-calendar-next-month-btn {\n    &:hover {\n      color: ", "!important;\n      outline-color: ", "!important;\n    }\n  }\n\n  .ant-calendar-my-select, .ant-calendar-year-panel-cell {\n    a:hover  {\n      color: ", ";\n    } \n  }\n\n  .ant-calendar-month-panel-cell:not(.ant-calendar-month-panel-selected-cell) {\n    &:hover {\n      .ant-calendar-month-panel-month {\n        color: ", ";\n      }\n    }\n  }\n\n  .ant-calendar-month-panel-selected-cell:not(.ant-calendar-disabled-cell) {\n    .ant-calendar-month-panel-month {\n      background-color: ", ";\n    }\n  }\n\n .ant-calendar-cell {\n    .ant-calendar-date:active {\n      background-color: ", ";\n    }\n\n    &.ant-calendar-selected-day:not(.ant-calendar-disabled-cell) {\n      div {\n        border-color: ", ";\n        color: #fff!important;\n      }\n      .ant-calendar-date {\n        background-color: ", ";\n      }\n    }\n\n    &.ant-calendar-today:not(.ant-calendar-selected-day):not(.ant-calendar-disabled-cell) {\n      .ant-calendar-date {\n        border-color: ", ";\n        color: ", ";\n      }\n    }\n  }\n"])), function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
}, function (props) {
  return props.theme.platformPrimary;
});
var App = /*#__PURE__*/function (_react$Component) {
  _inherits(App, _react$Component);
  function App() {
    _classCallCheck(this, App);
    return _possibleConstructorReturn(this, _getPrototypeOf(App).apply(this, arguments));
  }
  _createClass(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var accessToken = sessionStorage.getItem('access_token');
      if (this.props.platform !== _platforms2.default.ADMIN) {
        this.props.getPlatformDetails();
      }
      if (accessToken) {
        this.props.fetchUserInformation();
        this.props.pushNotificationsConnect();
      }
    }
  }, {
    key: "isPlatformDataFetching",
    value: function isPlatformDataFetching() {
      var _this$props = this.props,
        detailsFetched = _this$props.detailsFetched,
        exists = _this$props.exists,
        spFetched = _this$props.spFetched;
      return !detailsFetched || detailsFetched && exists && !spFetched;
    }
  }, {
    key: "render",
    value: function render() {
      var defaultTheme = _extends({}, _theme2.default, {
        platformPrimary: this.props.theme === _themes2.default.WHITE ? _colors2.default.blue.base : _colors2.default.blue.light,
        name: this.props.theme
      });
      if (this.props.platform === _platforms2.default.ADMIN) {
        return _react2.default.createElement(_styledComponents.ThemeProvider, {
          theme: _extends({}, defaultTheme, {
            platformPrimary: _colors2.default.blue.base
          })
        }, this.props.children);
      }
      var _this$props2 = this.props,
        spPlatformConfig = _this$props2.spPlatformConfig,
        detailsFetched = _this$props2.detailsFetched,
        exists = _this$props2.exists,
        spFetched = _this$props2.spFetched;
      var theme = spPlatformConfig && spPlatformConfig.accentColor && spPlatformConfig.hoverColor ? _extends({}, defaultTheme, {
        platformPrimary: this.props.theme === _themes2.default.WHITE ? spPlatformConfig.accentColor : spPlatformConfig.hoverColor
      }) : defaultTheme;
      return _react2.default.createElement(_styledComponents.ThemeProvider, {
        theme: theme
      }, _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(GlobalStyle, null), !this.isPlatformDataFetching() && this.props.children));
    }
  }]);
  return App;
}(_react.Component);
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var theme = state.user.info.theme;
  if (ownProps.platform !== _platforms2.default.ADMIN) {
    var _state$spPlatform = state.spPlatform,
      spPlatformConfig = _state$spPlatform.config,
      spFetched = _state$spPlatform.fetched,
      _state$user$strategic = state.user.strategicPartners,
      detailsFetched = _state$user$strategic.detailsFetched,
      exists = _state$user$strategic.exists;
    return {
      theme: theme,
      spPlatformConfig: spPlatformConfig,
      spFetched: spFetched,
      detailsFetched: detailsFetched,
      exists: exists
    };
  }
  return {
    theme: theme
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getPlatformDetails: function getPlatformDetails() {
      return dispatch((0, _firstLoadUnAuthAction.getPlatformDetails)());
    },
    fetchUserInformation: function fetchUserInformation() {
      return dispatch((0, _userDataActions.fetchUserInformation)());
    },
    pushNotificationsConnect: function pushNotificationsConnect() {
      return dispatch((0, _pushNotificationsActions.pushNotificationsConnectAction)());
    }
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);